<div class="container-fluid" wl-ng-models-valid (onValidChange)="handleFormValidChanged($event)">
  <wl-busy [show]="loading"></wl-busy>
  <div class="form-horizontal" [hidden]="loading" *ngIf="message">
    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'communications.mass-comm-message-edit.mass-comm-profiles.from-email-label' | translate | titlecase }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <input
          type="text"
          class="form-control"
          #messageSendFromField="ngModel"
          [(ngModel)]="message.SendFrom"
          [required]="!readonly"
          [disabled]="readonly && !isResend"
        />
        <div class="text-danger" [hidden]="!messageSendFromField.errors?.required">{{ 'common.required' | translate | titlecase }}</div>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'communications.mass-comm-message-edit.mass-comm-profiles.from-name-label' | translate | titlecase }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <input
          type="text"
          class="form-control"
          #messageSendFromDisplayNameField="ngModel"
          [(ngModel)]="message.SendFromDisplayName"
          [required]="!readonly"
          [disabled]="readonly && !isResend"
        />
        <div class="text-danger" [hidden]="!messageSendFromDisplayNameField.errors?.required">
          {{ 'common.required' | translate | titlecase }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'communications.mass-comm-message-edit.mass-comm-profiles.to-label' | translate | titlecase }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <select class="form-control" [(ngModel)]="toAction" (change)="handleToActionChange()" [disabled]="readonly || isResend">
          <option value="">
            {{ 'communications.mass-comm-message-edit.mass-comm-profiles.to-action-options.prompt' | translate | titlecase }}
          </option>
          <option *ngIf="isDraft" value="newListFromProfileSelector">
            {{ 'communications.mass-comm-message-edit.mass-comm-profiles.to-action-options.profile-selector' | translate | titlecase }}
          </option>
          <option *ngIf="isDraft" value="selectSavedDataView">
            {{ 'communications.mass-comm-message-edit.mass-comm-profiles.to-action-options.saved-data' | translate | titlecase }}
          </option>
          <option *ngIf="isDraft && revenueModuleReadAccess" value="newListFromInvoiceSelector">
            {{ 'communications.mass-comm-message-edit.mass-comm-profiles.to-action-options.invoice-selector' | translate | titlecase }}
          </option>
          <option value="addManualEmail">
            {{ 'communications.mass-comm-message-edit.mass-comm-profiles.to-action-options.add-manual-email' | translate | titlecase }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group" *ngIf="commonDataViewProfileAdvancedSearchParams">
      <div class="col-sm-offset-3 col-lg-offset-2 col-sm-9 col-lg-10">
        <div class="input-group">
          <wl-common-data-view-selector
            cssClass="form-control"
            [(ngModel)]="commonDataViewProfileAdvancedSearchParams.CommonDataView"
            [prompt]="('common.select' | translate | titlecase) + '...'"
            [disabled]="checkingProfileDoNotSent"
          ></wl-common-data-view-selector>
          <span class="input-group-btn">
            <button
              pButton
              type="button"
              class="atlas-btn atlas-btn-primary tall ml-5"
              (click)="handleCommonDataViewStartSearch()"
              [disabled]="checkingProfileDoNotSent || !commonDataViewProfileAdvancedSearchParams.CommonDataView"
              [icon]="!checkingProfileDoNotSent ? 'pi pi-play-circle' : ''"
            >
              <wl-busy *ngIf="checkingProfileDoNotSent" [show]="checkingProfileDoNotSent"></wl-busy>
            </button>
            <button
              pButton
              type="button"
              class="atlas-btn atlas-btn-default tall ml-5"
              (click)="handleCommonDataViewClear()"
              [disabled]="checkingProfileDoNotSent"
              icon="pi pi-times-circle"
            ></button>
          </span>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="isDraft && message?.ProfileSearchParams">
      <div class="col-sm-offset-3 col-lg-offset-2 col-sm-9 col-lg-10">
        <ul class="list-unstyled">
          <li>
            <label>
              <input
                type="checkbox"
                [(ngModel)]="useMainContact"
                (change)="handleMassCommReplaceTypeClick()"
                [disabled]="isSearching || useBillingContactFallThrough || useEmailTypeSelection"
              />
              {{
                'communications.mass-comm-message-edit.mass-comm-profiles.email-address-setup-option.replace-with-main-contact-email-label'
                  | translate
              }}
            </label>
            <ul
              class="list-unstyled simple-indent"
              [hidden]="message.ProfileSearchParams.ReplaceEmailAddressOption != replaceEmailAddressOptionValues.MainContact"
            >
              <li>
                <label>
                  <input
                    type="checkbox"
                    [(ngModel)]="message.ProfileSearchParams.ReplaceEmailOnlyIfPrimaryEmailIsBlank"
                    (change)="handleMassCommReplaceTypeClick()"
                    [disabled]="isSearching"
                  />
                  {{
                    'communications.mass-comm-message-edit.mass-comm-profiles.email-address-setup-option.replace-with-main-contact-email-blank-profile-optional-label'
                      | translate
                  }}
                </label>
              </li>
            </ul>
          </li>
          <li>
            <label>
              <input
                type="checkbox"
                [(ngModel)]="this.useBillingContactFallThrough"
                (change)="handleMassCommReplaceTypeClick()"
                [disabled]="isSearching || useMainContact || useEmailTypeSelection"
              />
              {{
                'communications.mass-comm-message-edit.mass-comm-profiles.email-address-setup-option.replace-with-billing-contact-email-label'
                  | translate
              }}
            </label>
            <ul class="list-unstyled simple-indent" [hidden]="!this.useBillingContactFallThrough">
              <li>
                <label>
                  <input
                    type="checkbox"
                    [(ngModel)]="this.useInvoiceContact"
                    (change)="handleMassCommReplaceTypeClick()"
                    [disabled]="isSearching"
                  />
                  {{
                    'communications.mass-comm-message-edit.mass-comm-profiles.email-address-setup-option.replace-with-invoice-contact-email-label'
                      | translate
                  }}
                </label>
              </li>
              <li>
                <label>
                  <input
                    type="checkbox"
                    [(ngModel)]="message.ProfileSearchParams.ReplaceEmailOnlyIfPrimaryEmailIsBlank"
                    (change)="handleMassCommReplaceTypeClick()"
                    [disabled]="isSearching"
                  />
                  {{
                    'communications.mass-comm-message-edit.mass-comm-profiles.email-address-setup-option.replace-with-billing-contact-email-blank-profile-optional-label'
                      | translate
                  }}
                </label>
              </li>
            </ul>
          </li>
          <li>
            <label>
              <input
                type="checkbox"
                [(ngModel)]="useEmailTypeSelection"
                (change)="handleMassCommReplaceTypeClick()"
                [disabled]="isSearching || useMainContact || useBillingContactFallThrough"
              />
              {{ 'communications.mass-comm-message-edit.mass-comm-profiles.email-address-setup-option.use-email-types-label' | translate }}
            </label>
            <span *ngIf="message.ProfileSearchParams.ReplaceWithEmailTypeConfig?.UsePrimary">{{
              'communications.mass-comm-message-edit.mass-comm-profiles.email-address-setup-option.use-email-types-primary-label'
                | translate
                | titlecase
            }}</span>

            <span *ngFor="let emailTypeId of message.ProfileSearchParams.ReplaceWithEmailTypeConfig?.EmailAddressTypeIds">
              {{ emailTypes[emailTypeId] }}
            </span>
            <span *ngIf="message.ProfileSearchParams.ReplaceEmailAddressOption == replaceEmailAddressOptionValues.EmailType"
              >(<a href="#" (click)="$event.preventDefault(); launchEmailTypeChooser()">{{
                'communications.mass-comm-message-edit.mass-comm-profiles.email-address-setup-option.change-email-types'
                  | translate
                  | titlecase
              }}</a
              >)</span
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="panel" [hidden]="!message?.ProfileSearchParams?.UnionProfileSearches">
      <div class="panel-heading">
        <div class="container-fluid form-horizontal">
          <div class="form-group">
            <div class="col-md-4">
              <div style="padding-bottom: 0.5em; padding-top: 0.5em">
                {{ 'communications.mass-comm-message-edit.mass-comm-profiles.search-summary-aggregate-header' | translate | titlecase }}
              </div>
            </div>
            <div class="col-md-4 pull-right">
              <button class="atlas-btn atlas-btn-default pull-right" (click)="toggleSummariesVisible()">
                {{
                  showSummaries
                    ? ('profiles.search.summary.hide-summary-button' | translate | titlecase)
                    : ('profiles.search.summary.show-summary-button' | translate | titlecase)
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-body" [hidden]="!showSummaries">
        <ul class="list-unstyled" [hidden]="!message?.ProfileSearchParams?.UnionProfileSearches?.length">
          <li *ngFor="let params of message?.ProfileSearchParams?.UnionProfileSearches">
            <wl-profile-search-summary summaryVisible="true" [searchParams]="params"></wl-profile-search-summary>
          </li>
        </ul>
        <ul class="list-unstyled" [hidden]="!message?.ProfileSearchParams?.UnionInvoiceSearches?.length">
          <li *ngFor="let params of message?.ProfileSearchParams?.UnionInvoiceSearches">
            <wl-invoice-selector-summary summaryVisible="true" [searchParams]="params"></wl-invoice-selector-summary>
          </li>
        </ul>
        <div class="col.md-4 pull-right">
          <a class="pull-right" href="#" (click)="$event.preventDefault(); confirmClearSearchCriteriaMessage()">{{
            'profiles.search.summary.clear-all-search-criteria' | translate | titlecase
          }}</a>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="message?.ProfileSearchParams?.UnionProfileSearches">
      <div class="col-sm-12">
        <div class="pull-right" [hidden]="!recipientResult.TotalCount">
          <wl-busy *ngIf="isSearching" [show]="isSearching"></wl-busy>

          {{ recipientResult.TotalCount }}
          <span *ngIf="isDraft && message?.ProfileSearchParams">{{
            recipientResult.TotalCount == 1
              ? ('communications.mass-comm-message-edit.mass-comm-profiles.profile' | translate | titlecase)
              : ('communications.mass-comm-message-edit.mass-comm-profiles.profiles' | translate | titlecase)
          }}</span>
          <span *ngIf="!isDraft">{{
            recipientResult.TotalCount == 1
              ? ('communications.mass-comm-message-edit.mass-comm-profiles.email' | translate | titlecase)
              : ('communications.mass-comm-message-edit.mass-comm-profiles.emails' | translate | titlecase)
          }}</span>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="isDraft && message?.ProfileSearchParams">
      <div class="col-sm-12">
        <div class="input-group">
          <select class="form-control" [(ngModel)]="gridAction" [disabled]="recipientResult.TotalCount <= 0 || gridActionBusy">
            <option value="">
              {{ 'communications.mass-comm-message-edit.mass-comm-profiles.grid-action-options.prompt' | translate | titlecase }}
            </option>
            <option value="removeSelected" *ngIf="!readonly">
              {{
                'communications.mass-comm-message-edit.mass-comm-profiles.grid-action-options.remove-selected-rows' | translate | titlecase
              }}
            </option>
            <option value="exportToExcel">
              {{ 'communications.mass-comm-message-edit.mass-comm-profiles.grid-action-options.export-to-excel' | translate | titlecase }}
            </option>
          </select>
          <span class="input-group-btn">
            <wl-busy [show]="gridActionBusy"></wl-busy>
            <button
              pButton
              type="button"
              class="atlas-btn atlas-btn-primary tall ml-5"
              (click)="executeGridAction()"
              [disabled]="!gridAction || gridActionBusy"
              icon="pi pi-play-circle"
            ></button>
          </span>
        </div>
      </div>
    </div>
  </div>

  <p-table
    [showGridlines]="true"
    *ngIf="message"
    #recipientGrid
    [rows]="20"
    styleClass="wl-responsive-prime-datatable"
    [value]="recipientResult.Result"
    [paginator]="true"
    (onLazyLoad)="lazyLoadRecipientProfiles($event)"
    [totalRecords]="recipientResult.TotalCount"
    [sortField]="isDraft ? 'ReportName' : 'SendToDisplayName'"
    [sortOrder]="1"
    [lazy]="true"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 80px" *ngIf="!isResend">
          <div class="text-center">
            <input type="checkbox" [(ngModel)]="recipientsSelectedAll" (change)="handleRecipientGridSelectAll($event)" />
          </div>
        </th>
        <th class="wl-prime-datatable-hidden-phone" [pSortableColumn]="'ProfileId'" style="width: 120px">
          {{ 'communications.mass-comm-message-edit.mass-comm-profiles.profile-id-column-header' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="isDraft ? 'ReportName' : 'SendToDisplayName'">
          {{ 'communications.mass-comm-message-edit.mass-comm-profiles.profile-name-column-header' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th class="wl-prime-datatable-hidden-phone" [pSortableColumn]="isDraft ? 'Email' : 'SendTo'">
          {{ 'communications.mass-comm-message-edit.mass-comm-profiles.email-column-header' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th class="wl-prime-datatable-hidden-phone" style="width: 220px">
          {{ 'communications.mass-comm-message-edit.mass-comm-profiles.type-column-header' | translate | titlecase }}
        </th>
      </tr>
    </ng-template>
    <ng-template let-recipient pTemplate="body">
      <tr>
        <td *ngIf="!isResend">
          <div class="text-center">
            <input type="checkbox" [(ngModel)]="recipient.selected" (change)="handleRecipientSelected($event, recipient)" />
          </div>
        </td>
        <td class="wl-prime-datatable-hidden-phone">{{ recipient.ProfileId }}</td>
        <td>
          <div class="wl-prime-datatable-hidden-phone">
            <wl-profile-type-icon
              *ngIf="recipient && recipient.ProfileId"
              [isMember]="recipient.Member"
              [isOrg]="recipient.OrgInd"
              [profileId]="recipient.ProfileId"
              [memberTypeIconColor]="recipient.MemberTypeIconColor"
            ></wl-profile-type-icon>
            {{ recipient.Name }}
          </div>
          <div class="wl-prime-datatable-hidden-tablet-and-bigger">
            <div>
              <strong
                >{{ 'communications.mass-comm-message-edit.mass-comm-profiles.profile-id-column-header' | translate | titlecase }}:</strong
              >
              {{ recipient.ProfileId }}
            </div>
            <div>
              <strong
                >{{
                  'communications.mass-comm-message-edit.mass-comm-profiles.profile-name-column-header' | translate | titlecase
                }}:</strong
              >
              {{ recipient.Member
              }}<wl-profile-type-icon
                *ngIf="recipient && recipient.ProfileId"
                [isMember]="recipient.Member"
                [isOrg]="recipient.OrgInd"
                [profileId]="recipient.ProfileId"
                [memberTypeIconColor]="recipient.MemberTypeIconColor"
              ></wl-profile-type-icon>
              {{ recipient.Name }}
            </div>
            <div>
              <strong>{{ 'communications.mass-comm-message-edit.mass-comm-profiles.email-column-header' | translate | titlecase }}:</strong>
              {{ recipient.Email }}
            </div>
            <div>
              <strong>{{ 'communications.mass-comm-message-edit.mass-comm-profiles.type-column-header' | translate | titlecase }}:</strong>
              {{ recipient.EmailType }}
            </div>
          </div>
        </td>
        <td class="wl-prime-datatable-hidden-phone">
          <div style="overflow: hidden">{{ recipient.Email }}</div>
        </td>
        <td class="wl-prime-datatable-hidden-phone">
          {{ recipient.EmailType }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center">
          {{ 'common.phrases.no-results-found' | translate | titlecase }}
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>

  <div *ngIf="message && isDraft && message.ManualRecipients?.length" class="marginalize">
    <h3>{{ 'communications.mass-comm-message-edit.mass-comm-profiles.add-manual.title' | translate }}</h3>
    <p>
      <span class="pull-right">
        {{ message.ManualRecipients.length }}
        {{
          message.ManualRecipients.length == 1
            ? ('communications.mass-comm-message-edit.mass-comm-profiles.email' | translate | titlecase)
            : ('communications.mass-comm-message-edit.mass-comm-profiles.emails' | translate | titlecase)
        }}
      </span>
      <button
        app-add-button
        class="atlas-btn atlas-btn-primary"
        [label]="'common.add' | translate | titlecase"
        (click)="openAddManualRecipient()"
      ></button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-danger tall ml-5"
        (click)="removeSelectedManualRecipient()"
        [disabled]="!manualRecipientsSelectedAll && !manualRecipientsManuallyChecked?.length"
        icon="pi pi-trash"
      >
        {{ 'common.remove' | translate | titlecase }}
      </button>
    </p>
  </div>

  <p-table
    [showGridlines]="true"
    #manuallyAddedRecipientGrid
    *ngIf="message && isDraft && message.ManualRecipients?.length"
    [rows]="20"
    styleClass="wl-responsive-prime-datatable"
    [value]="message.ManualRecipients"
    [paginator]="true"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th [hidden]="!isDraft">
          <div class="text-center">
            <input type="checkbox" [(ngModel)]="manualRecipientsSelectedAll" (change)="handleManualRecipientGridSelectAll($event)" />
          </div>
        </th>
        <th [pSortableColumn]="'Name'">
          {{ 'communications.mass-comm-message-edit.mass-comm-profiles.profile-name-column-header' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th class="wl-prime-datatable-hidden-phone" [pSortableColumn]="'Email'">
          {{ 'communications.mass-comm-message-edit.mass-comm-profiles.email-column-header' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-recipient>
      <tr>
        <td [hidden]="!isDraft">
          <div class="text-center">
            <input type="checkbox" [(ngModel)]="recipient.selected" (change)="handleManualRecipientSelected($event, recipient)" />
          </div>
        </td>
        <td>
          <div class="wl-prime-datatable-hidden-phone">{{ recipient.Name }}</div>
          <div class="wl-prime-datatable-hidden-tablet-and-bigger">
            <div>
              <strong
                >{{
                  'communications.mass-comm-message-edit.mass-comm-profiles.profile-name-column-header' | translate | titlecase
                }}:</strong
              >
              {{ recipient.Name }}
            </div>
            <div>
              <strong>{{ 'communications.mass-comm-message-edit.mass-comm-profiles.email-column-header' | translate | titlecase }}:</strong>
              {{ recipient.Email }}
            </div>
          </div>
        </td>
        <td class="wl-prime-datatable-hidden-phone">
          <div style="overflow: hidden">{{ recipient.Email }}</div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
</div>

<p-dialog
  #profileSearchParamsModal
  modal="true"
  [(visible)]="showSearchParamsModal"
  [closable]="false"
  styleClass="atlas-dialog-xl"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '70vh', 'min-height': '70vh' }"
>
  <ng-template pTemplate="header">
    <h3>{{ 'communications.mass-comm-message-edit.mass-comm-profiles.profile-selector-title' | translate | titlecase }}</h3>
  </ng-template>
  <div *ngIf="profileAdvancedSearchEnabled">
    <div class="container-fluid">
      <div class="form-horizontal" *ngIf="message && isDraft">
        <div class="form-group">
          <div class="mct-basis-50">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                wl-on-enter-press
                (onEnterPess)="previewProfileSearchParamsClick()"
                [(ngModel)]="profileSearchParams.Keyword"
                [placeholder]="
                  'communications.mass-comm-message-edit.mass-comm-profiles.selector-keyword-placeholder' | translate | titlecase
                "
                [disabled]="previewingProfilesAdvancedSearch || checkingProfileDoNotSent"
              />
              <span class="input-group-btn">
                <button
                  pButton
                  type="button"
                  class="atlas-btn atlas-btn-default"
                  (click)="previewProfileSearchParamsClick()"
                  [disabled]="previewingProfilesAdvancedSearch || checkingProfileDoNotSent"
                  [icon]="!previewingProfilesAdvancedSearch ? 'pi pi-search' : ''"
                >
                  <wl-busy [show]="previewingProfilesAdvancedSearch"></wl-busy>
                </button>
                <button
                  pButton
                  type="button"
                  class="atlas-btn atlas-btn-default"
                  (click)="previewProfileClearParamsClick()"
                  [disabled]="previewingProfilesAdvancedSearch || checkingProfileDoNotSent"
                  icon="pi pi-times-circle"
                ></button>
              </span>
            </div>
          </div>
        </div>
        <div>
          <wl-profile-advanced-search-options
            [searchParams]="profileSearchParams"
            [hideRunThisSearchButton]="true"
          ></wl-profile-advanced-search-options>
        </div>
      </div>
    </div>

    <div class="container-fluid marginalize" [hidden]="!previewProfileSelectorSearched">
      <p-table
        [showGridlines]="true"
        #profileSearchParamsGrid
        [rows]="20"
        styleClass="wl-responsive-prime-datatable"
        [value]="profileSearchParamsResult.Result"
        [paginator]="true"
        (onLazyLoad)="lazyLoadProfileSearchParamsPreview($event)"
        [lazy]="true"
        [totalRecords]="profileSearchParamsResult.TotalCount"
      >
        <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
          <SortAltIcon *ngIf="sortOrder === 0">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
          </SortAltIcon>
          <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
          </SortAmountUpAltIcon>
          <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
          </SortAmountDownIcon>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'ProfileId'" class="wl-prime-datatable-hidden-phone" style="width: 120px">
              {{ 'communications.mass-comm-message-edit.mass-comm-profiles.profile-id-column-header' | translate | titlecase }}
              <p-sortIcon></p-sortIcon>
            </th>
            <th [pSortableColumn]="'ReportName'" class="wl-prime-datatable-hidden-phone">
              {{ 'communications.mass-comm-message-edit.mass-comm-profiles.report-name-column-header' | translate | titlecase }}
              <p-sortIcon></p-sortIcon>
            </th>
            <th [pSortableColumn]="'Email'" class="wl-prime-datatable-hidden-phone">
              {{ 'communications.mass-comm-message-edit.mass-comm-profiles.email-column-header' | translate | titlecase }}
              <p-sortIcon></p-sortIcon>
            </th>
            <th class="wl-prime-datatable-hidden-phone">
              {{ 'communications.mass-comm-message-edit.mass-comm-profiles.type-column-header' | translate | titlecase }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-profile>
          <tr>
            <td class="wl-prime-datatable-hidden-phone">{{ profile.ProfileId }}</td>
            <td class="wl-prime-datatable-hidden-phone">
              <wl-profile-type-icon
                *ngIf="profile && profile.ProfileId"
                [isMember]="profile.Member"
                [isOrg]="profile.OrgInd"
                [profileId]="profile.ProfileId"
                [memberTypeIconColor]="profile.MemberTypeIconColor"
              ></wl-profile-type-icon>
              {{ profile.ReportName }}
            </td>
            <td class="wl-prime-datatable-hidden-phone">
              <div style="overflow: hidden">{{ profile.Email }}</div>
            </td>
            <td class="wl-prime-datatable-hidden-phone">
              {{ profile.EmailType }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td colspan="4">
              <wl-busy [show]="previewingProfilesAdvancedSearch"></wl-busy>
              <div [hidden]="previewingProfilesAdvancedSearch" class="pull-right">
                {{ profileSearchParamsResult.TotalCount }}
                {{ 'communications.mass-comm-message-edit.mass-comm-profiles.profiles' | translate | titlecase }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-progressSpinner *ngIf="loading"></p-progressSpinner>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="alert alert-danger" *ngIf="profileSearchParamsModalError">{{ profileSearchParamsModalError }}</div>
    <wl-busy [show]="previewingProfilesAdvancedSearch || checkingProfileDoNotSent"></wl-busy>
    <button
      type="button"
      pButton
      class="atlas-btn atlas-btn-default"
      (click)="previewProfileSearchParamsClick()"
      [disabled]="previewingProfilesAdvancedSearch || checkingProfileDoNotSent"
    >
      {{ 'common.preview' | translate | titlecase }}
    </button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-default"
      (click)="acceptProfileSearchParamsClick()"
      [disabled]="previewingProfilesAdvancedSearch || checkingProfileDoNotSent"
      icon="pi pi-check"
    >
      {{ 'communications.mass-comm-message-edit.mass-comm-profiles.email-list-button' | translate | titlecase }}
    </button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-secondary"
      (click)="this.showSearchParamsModal = false"
      [disabled]="checkingProfileDoNotSent"
      icon="pi pi-ban"
    >
      {{ 'common.cancel' | translate | titlecase }}
    </button>
  </ng-template>
</p-dialog>

<p-dialog
  #doNotEmailProfilesModal
  modal="true"
  [(visible)]="showDoNotEmailModal"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    {{ 'communications.mass-comm-message-edit.mass-comm-profiles.override-column-prompt' | translate }}
  </ng-template>
  <p-table
    [showGridlines]="true"
    #doNotEmailProfilesGrid
    [rows]="20"
    styleClass="wl-responsive-prime-datatable"
    [value]="doNotEmailProfilesResult.Result"
    [paginator]="true"
    (onLazyLoad)="lazyLoadDoNotEmailProfiles($event)"
    [totalRecords]="doNotEmailProfilesResult.TotalCount"
    [lazy]="true"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th [hidden]="!isDraft" class="text-center" style="width: 120px">
          <label>
            {{ 'communications.mass-comm-message-edit.mass-comm-profiles.override-column-header' | translate | titlecase }}
          </label>
          <input
            type="checkbox"
            [(ngModel)]="doNotEmailProfilesOverrideSelectedAll"
            (change)="handleDoNotEmailProfileGridSelectAll($event)"
          />&nbsp;
        </th>
        <th [pSortableColumn]="'ProfileId'" class="wl-prime-datatable-hidden-phone text-center" style="width: 120px">
          {{ 'communications.mass-comm-message-edit.mass-comm-profiles.profile-id-column-header' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'ReportName'" class="wl-prime-datatable-hidden-phone text-center">
          {{ 'communications.mass-comm-message-edit.mass-comm-profiles.profile-name-column-header' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'Email'" class="wl-prime-datatable-hidden-phone text-center">
          {{ 'communications.mass-comm-message-edit.mass-comm-profiles.email-column-header' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th class="wl-prime-datatable-hidden-phone text-center" style="width: 120px">
          {{ 'communications.mass-comm-message-edit.mass-comm-profiles.type-column-header' | translate | titlecase }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-profile>
      <tr>
        <td [hidden]="!isDraft" class="text-left">
          <input type="checkbox" [(ngModel)]="profile.selected" (change)="handleDoNotEmailProfileSelected($event, profile)" />
          <div class="wl-prime-datatable-hidden-tablet-and-bigger">
            <div>
              <strong
                >{{ 'communications.mass-comm-message-edit.mass-comm-profiles.profile-id-column-header' | translate | titlecase }}:</strong
              >
              {{ profile.ProfileId }}
            </div>
            <div>
              <strong
                >{{
                  'communications.mass-comm-message-edit.mass-comm-profiles.profile-name-column-header' | translate | titlecase
                }}:</strong
              >
              <wl-profile-type-icon
                *ngIf="profile && profile.ProfileId"
                [isMember]="profile.Member"
                [isOrg]="profile.OrgInd"
                [profileId]="profile.ProfileId"
                [memberTypeIconColor]="profile.MemberTypeIconColor"
              ></wl-profile-type-icon>
              {{ profile.ReportName }}
            </div>
            <div>
              <strong>{{ 'communications.mass-comm-message-edit.mass-comm-profiles.email-column-header' | translate | titlecase }}:</strong>
              {{ profile.Email }}
            </div>
            <div>
              <strong>{{ 'communications.mass-comm-message-edit.mass-comm-profiles.type-column-header' | translate | titlecase }}:</strong>
              {{ profile.EmailType }}
            </div>
          </div>
        </td>
        <td class="wl-prime-datatable-hidden-phone">
          {{ profile.ProfileId }}
        </td>
        <td class="wl-prime-datatable-hidden-phone">
          <wl-profile-type-icon
            *ngIf="profile && profile.ProfileId"
            [isMember]="profile.Member"
            [isOrg]="profile.OrgInd"
            [profileId]="profile.ProfileId"
            [memberTypeIconColor]="profile.MemberTypeIconColor"
          ></wl-profile-type-icon>
          {{ profile.ReportName }}
        </td>
        <td class="wl-prime-datatable-hidden-phone">
          <div style="overflow: hidden">{{ profile.Email }}</div>
        </td>
        <td class="wl-prime-datatable-hidden-phone">
          {{ profile.EmailType }}
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
  <ng-template pTemplate="footer">
    <div class="alert alert-danger" *ngIf="gettingAllDoNotEmailProfileIdError">{{ gettingAllDoNotEmailProfileIdError }}</div>
    <wl-busy [show]="loadingDoNotEmailProfiles || gettingAllDoNotEmailProfileIds"></wl-busy>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      (click)="acceptDoNotEmailProfilesClick()"
      [disabled]="loadingDoNotEmailProfiles || gettingAllDoNotEmailProfileIds"
      icon="pi pi-check"
    >
      {{ 'common.continue' | translate | titlecase }}
    </button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-secondary"
      (click)="this.showDoNotEmailModal = false"
      [disabled]="loadingDoNotEmailProfiles || gettingAllDoNotEmailProfileIds"
      icon="pi pi-ban"
    >
      {{ 'common.cancel' | translate | titlecase }}
    </button>
  </ng-template>
</p-dialog>

<wl-mass-comm-message-edit-profiles-add-manual
  #addManualRecipients
  (newAdditionalEmails)="handleNewManualRecipients($event)"
></wl-mass-comm-message-edit-profiles-add-manual>

<p-dialog
  #emailTypeConfigModal
  modal="true"
  [(visible)]="showEmailTypeModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h3>{{ 'communications.mass-comm-message-edit.mass-comm-profiles.email-type-config.title' | translate | titlecase }}</h3>
  </ng-template>
  <wl-mass-comm-message-edit-profiles-email-type-config
    [replaceWithEmailTypeConfig]="editingEmailTypeConfig"
  ></wl-mass-comm-message-edit-profiles-email-type-config>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="accepEmailTypeConfigClick()" icon="pi pi-save">
      {{ 'common.save' | translate | titlecase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="this.showEmailTypeModal = false" icon="pi pi-ban">
      {{ 'common.cancel' | translate | titlecase }}
    </button>
  </ng-template>
</p-dialog>

<p-dialog
  #invoiceSelectorModal
  modal="true"
  [(visible)]="showInvoiceSelectorModal"
  [closable]="false"
  styleClass="atlas-dialog-xl"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '70vh' }"
>
  <ng-template pTemplate="header">
    <h3>{{ 'communications.mass-comm-message-edit.mass-comm-profiles.invoice-selector-title' | translate | titlecase }}</h3>
  </ng-template>
  <wl-invoice-selector
    #invoiceSelector
    *ngIf="invoiceSelectorEnabled"
    [searchParams]="invoiceSelectorSearchParams"
    (searching)="isInvoiceSelectorSearching = $event"
  ></wl-invoice-selector>
  <ng-template pTemplate="footer">
    <div class="mct-flex mct-col mct-justify-center mct-items-end mct-gap-5">
      <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-5">
        <div class="alert alert-danger" *ngIf="invoiceSelectorModalError">{{ invoiceSelectorModalError }}</div>
        <wl-busy [show]="isInvoiceSelectorSearching || checkingProfileDoNotSent"></wl-busy>
        <button
          type="button"
          class="atlas-btn atlas-btn-secondary"
          (click)="invoiceSelectorSearch()"
          [disabled]="isInvoiceSelectorSearching || checkingProfileDoNotSent"
        >
          {{ 'common.preview' | translate | titlecase }}
        </button>
        <button
          pButton
          type="button"
          class="atlas-btn atlas-btn-primary"
          (click)="acceptInvoiceSelectorClick()"
          [disabled]="isInvoiceSelectorSearching || checkingProfileDoNotSent"
          icon="pi pi-check"
        >
          {{ 'communications.mass-comm-message-edit.mass-comm-profiles.email-list-button' | translate | titlecase }}
        </button>
        <button
          pButton
          type="button"
          class="atlas-btn atlas-btn-secondary"
          (click)="this.showInvoiceSelectorModal = false"
          [disabled]="checkingProfileDoNotSent"
          icon="pi pi-ban"
        >
          {{ 'common.cancel' | translate | titlecase }}
        </button>
      </div>
      <div class="w-100 mct-grid mass-comm-profiles-grid">
        <div>&nbsp;</div>
        <div class="mct-flex mct-col mct-justify-start mct-items-start">
          <div>
            <label>
              <input type="checkbox" [(ngModel)]="useBillingContactFallThrough" (change)="useBillingContactFallThroughChanged()" />
              {{ 'communications.mass-comm-message-edit.mass-comm-profiles.use-billing-contact-label' | translate }}
            </label>
          </div>
          <div class="ml-27">
            <label>
              <input type="checkbox" [(ngModel)]="useInvoiceContact" [disabled]="!useBillingContactFallThrough" />
              {{ 'communications.mass-comm-message-edit.mass-comm-profiles.use-invoice-contact' | translate }}
            </label>
          </div>
          <div class="ml-27">
            <label>
              <input type="checkbox" [(ngModel)]="overwriteBlankOnly" [disabled]="!useBillingContactFallThrough" />
              {{ 'communications.mass-comm-message-edit.mass-comm-profiles.billing-overwrite-blank-only' | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  #clearSearchCriteriaConfirmationModal
  modal="true"
  [(visible)]="showClearSearchModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [showHeader]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <p>{{ 'communications.mass-comm-message-edit.mass-comm-profiles.clear-search-criteria-confirmation-prompt' | translate }}</p>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="clearSearchCriteriaConfirmed()" icon="pi pi-trash">
      <span>
        {{ 'profiles.search.summary.clear-all-search-criteria' | translate | titlecase }}
      </span>
    </button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-secondary"
      (click)="clearSearchCriteriaConfirmationModal.close()"
      icon="pi pi-ban"
    >
      {{ 'common.cancel' | translate | titlecase }}
    </button>
  </ng-template>
</p-dialog>
